export default __webpack_public_path__ + "static/door4-ef5e211c5bb494f3e70af8e7a9b7aafc.jpg";